import {Component, EventEmitter, Output} from '@angular/core';
import {FriendsList} from '../../../../../../fack-db/friends-list';

@Component({
  selector: 'app-chat-user-list',
  templateUrl: './chat-user-list.component.html',
})
export class ChatUserListComponent {
  @Output() onChatCollapse = new EventEmitter();
  @Output() onChatToggle = new EventEmitter();
  public friendsList: any;

  constructor() {
    this.friendsList = FriendsList.friends;
  }
  onChatOn(friend_id) {
    this.onChatToggle.emit(friend_id);
  }

}
